<template>



  <a-html autoEnable="false">
    <div class="vr">
      <h1>
        {{ block.field_values.text }}
      </h1>
      <div v-html="block.field_values.html"></div>
    </div>
  </a-html>
<!--  -->
<!--    <a-entity-->
<!--        html="ppu: 1000; autoWidth: true; autoHeight: true"-->
<!--        geometry="primitive: plane; width:0; height: 0" material="visible: false; transparent: true"-->
<!--        yoga-layout-item="margin: 0; marginEdge: left; padding: 0"-->
<!--    >-->
<!--        <div class="vr vr-distance-1-5 vr-width-1-5 vr-height-auto xvr-padding">-->
<!--            <h1>-->
<!--                {{ block.field_values.text }}-->
<!--            </h1>-->
<!--            <div v-html="block.field_values.html"></div>-->
<!--        </div>-->
<!--    </a-entity>-->
</template>

<script>
export default {
    name: "Intro",
    props: ['block'],
}
</script>

<style scoped>
</style>